/**
 * Adapter logger - warns only once per key to avoid console spam
 */

const warnedKeys = new Set<string>();

/**
 * Log a console.warn only once per key.
 * Use a stable key (e.g. adapter name + reason) so the same condition doesn't spam.
 */
export function warnOnce(key: string, message: string): void {
  if (warnedKeys.has(key)) {
    return;
  }
  warnedKeys.add(key);
  console.warn(message);
}
